import { useQuery } from "@tanstack/react-query";

import { getAdminPracticeCrops, getPracticeCrops } from "services";

import { getEnvironment, useTranslation } from "utils";

import { DEFAULT_CACHE_TIME, GET_PRACTICES_CROPS } from "consts";

import { PracticeCrop, WithInjectedName } from "models";

const PLACEHOLDER_IMAGE_URL = "https://klimpublic.s3.eu-central-1.amazonaws.com/footprinting-crop-images/small/placeholder.webp";

// TODO: make an endpoint for this
export const useGetPracticeCrop = (cropId?: string) => {
  const crops = useGetPracticeCrops({ enabled: true });
  return crops.data?.find((crop) => crop.id === cropId);
};

const env = getEnvironment();

type PracticeCropWithDefaults = WithInjectedName<PracticeCrop> & {
  imageURL: string;
};

export const useGetPracticeCrops = ({ enabled, regionId, isAdmin = env.admin }: { enabled?: boolean; regionId?: string; isAdmin?: boolean }) => {
  // Not having { useSuspense: false } caused unintended UI behavior — like a drawer opening and closing on mount,
  // due to remounting triggered by Suspense fallback.
  // DO NOT REMOVE unless you're explicitly handling Suspense with fallback UIs.
  const { t } = useTranslation("practices", { useSuspense: false });

  return useQuery<Array<PracticeCropWithDefaults>>({
    queryKey: [GET_PRACTICES_CROPS, enabled, regionId, isAdmin],
    queryFn: async () => {
      const crops = await (isAdmin ? getAdminPracticeCrops({ enabled, regionId }) : getPracticeCrops({ enabled, regionId }));
      return crops.map((c) => ({
        ...c,
        name: t(`crops.${c.translationSlug}`),
        imageURL: c.imageURL || PLACEHOLDER_IMAGE_URL,
      }));
    },
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
